import { IconBase } from './IconBase'

type IconChevronDownProps = React.ComponentProps<'svg'>

export const IconChevronDown = (props: IconChevronDownProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.283 18.367a1.332 1.332 0 0 1-.383-.267L1.472 8.672a1.333 1.333 0 1 1 1.886-1.886L12 15.428 20.527 6.9a1.333 1.333 0 1 1 1.886 1.886l-9.428 9.428a1.334 1.334 0 0 1-1.702.154Z"
      />
    </IconBase>
  )
}
